type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info";

const tones: Record<BadgeTone, string> = {
  neutral: "border-line bg-white text-graphite",
  success: "border-pine/20 bg-mint text-pine",
  warning: "border-brass/25 bg-brass/10 text-[#76521f]",
  danger: "border-red-900/20 bg-red-50 text-red-900",
  info: "border-ink/10 bg-ink/5 text-ink",
};

export function Badge({
  children,
  tone = "neutral",
}: {
  children: string;
  tone?: BadgeTone;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${tones[tone]}`}
    >
      {children}
    </span>
  );
}
